import { style } from '@vanilla-extract/css'

const content = style({
  padding: '40px 24px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '24px',
})

const heading = style({
  fontSize: '18px',
  fontWeight: 'bold',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  textAlign: 'center',
});

const text = style({
  fontSize: '16px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  width: '100%',
});

const image = style({
  width: '100%',
});

export const styles = {
  content,
  heading,
  text,
  image,
}
